import { createNames } from "../../utils";
export const getAceSectionNames = (id) => {
    return createNames(id, 'ACE-SECTION', 'HEADER', '_OUTER_GUTTER____MOBILE', '_OUTER_GUTTER____TABLET', '_OUTER_GUTTER____DESKTOP', '____WITH_PADDING_TOP', '____WITH_PADDING_BOTTOM', '____FULL_WIDTH_MOBILE', '____FULL_WIDTH_TABLET', '_BACKGROUND_COLOR');
};
export const aceSectionCssVariables = {
    OUTER_GUTTER__MOBILE: '--ace-section-outer-gutter--mobile',
    OUTER_GUTTER__TABLET: '--ace-section-outer-gutter--tablet',
    OUTER_GUTTER__DESKTOP: '--ace-section-outer-gutter--desktop',
    PADDING_TOP: '--ace-section-padding-top',
    PADDING_BOTTOM: '--ace-section-padding-bottom',
    BACKGROUND_COLOR: '--ace-section-background-color',
};
export const aceSectionSlots = {
    TITLE: 'title',
    FOOTER: 'footer',
};
//# sourceMappingURL=ace-section.get-names.js.map
